import { StaticBaseDao } from '@/dao';
import { CategoryTemplate, Category, IntArray, PostResponse } from '@/objects/generated';

export class CategoryDao extends StaticBaseDao {
    public static async GetCategoryTemplates(sportId: number): Promise<CategoryTemplate[]> {
        return this.BaseFetchArray(
            CategoryTemplate,
            `Category/GetCategoryTemplates` + '?' + (sportId == undefined ? '' : `sportId=${sportId}`),
            'GET',
        );
    }
    public static async GetCategoriesForTemplate(templateId: number): Promise<Category[]> {
        return this.BaseFetchArray(
            Category,
            `Category/GetCategoriesForTemplate` + '?' + (templateId == undefined ? '' : `templateId=${templateId}`),
            'GET',
        );
    }
    public static async GetCategoriesForEvent(EventID: number): Promise<Category[]> {
        return this.BaseFetchArray(
            Category,
            `Category/GetCategoriesForEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async MergeCatagories(EventID: number, name: string | null, categoryIds: IntArray): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `Category/MergeCatagories` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (name == undefined ? '' : `name=${name}`),
            'POST',
            categoryIds,
        );
    }
}
